import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private suppressFunctionalErrorsUntil = 0;

  constructor(private messageService: MessageService) {}

  suppressFunctionalErrors(durationMs = 2500): void {
    this.suppressFunctionalErrorsUntil = Date.now() + durationMs;
  }

  showError(summary: string, detail: string) {
    if (Date.now() < this.suppressFunctionalErrorsUntil) {
      return;
    }

    this.messageService.add({
      severity: 'error',
      summary,
      detail,
    });
  }

  showSuccess(summary: string, detail: string) {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
    });
  }
}
